import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

import { _post } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import FormField from "../../../components/Form/FormField/FormField.component";
import LoadingButton from '../../../components/LoadingButton/LoadingButton.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const UserCategoriesList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('user_categories'), link: '/user-categories-list' },
		{ title: t('list') }
	];

	const [userCategories, setUserCategories] = useState([]);
	let userCategoriesListData = {
		head: [t('title'), t('status'), t('operation')],
		body: userCategories.map(userCategory => [
			userCategory.usercategory_name,
			<span className={"badge rounded-pill p-2 badge-subtle-" + (userCategory.is_active ? 'success' : 'secondary')}>
				{userCategory.is_active ? t('active') : t('deactive')}
			</span>,
			<Link className='btn btn-secondary btn-sm p-1' to={`/user-categories-edit/${userCategory.usercategory_id}`}>
				<i className="fa fa-edit"></i> {t('edit')}
			</Link>
		]),
		directions: ['rtl', '', 'ltr']
	};
	
	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchUserCategoryTitle, setSearchUserCategoryTitle] = useState(null);
	const [searchButtonIsLoading, setSearchButtonIsLoading] = useState(false);
	const [searchCounter, setSearchCounter] = useState(0);
	const getUserCategories = async () => {
		let body = {
			usercategory_name: searchUserCategoryTitle,
			page: pageNumber,
			count: pageCounter
		};
		setSearchButtonIsLoading(true);
		let response = await _post('/usercategories/admin/getAll', body);
		setSearchButtonIsLoading(false);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_usercategories);
				setUserCategories(response.data.usercategories);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};
	
	const filterUserCategories = event => {
		event.preventDefault();
		if(searchButtonIsLoading)
			return 0;
		let title = event.target.searchUserCategoryTitle.value.trim() || null;
		setSearchUserCategoryTitle(title);
		if(pageNumber === 1)
			setSearchCounter(searchCounter + 1);
		else
			setPageNumber(1);
	};
	
	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getUserCategories();
	}, [searchCounter]);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<div className="card mb-3">
				<div className="card-header">
					<h5 className="mb-0">{t('search_for')} {t('user_categories')}</h5>
				</div>
				<div className="card-body bg-light">
					<form onSubmit={filterUserCategories}>
						<div className="row gx-2">
							<FormField fieldKey="searchUserCategoryTitle" title={t('title')} value={searchUserCategoryTitle} isSearch={true} />
						</div>
						<div>
							<LoadingButton className="btn btn-primary d-inline-block mt-3 me-2" type="submit" name="create" isLoading={searchButtonIsLoading}>
								<i className="fa fa-search"></i> {t('search')}
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
			<ListTable title={t('user_categories')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={userCategoriesListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default UserCategoriesList;
